global.endpoint = 'https://www.webfactor.hu/siloam/';
global.post_per_page = 10;
global.facebook = 'https://www.facebook.com/profile.php?id=61562027897274';
global.instagram = 'https://www.instagram.com/siloambalatonfured/';